import { useUtilStore } from "~/store/util"
import type { PublicConfig } from "~/utils/types/config"

let popstateHandlerRegistered = false

export const useExitModal = () => {
  const utils = useUtilStore()
  const { exitModal, shouldShowExitModal } = storeToRefs(utils)

  const showExitModal = () => {
    if (shouldShowExitModal.value) {
      exitModal.value.show = true
    }
  }

  const handleLogoClick = (event: Event) => {
    if (shouldShowExitModal.value) {
      event.preventDefault()
      showExitModal()
    }
  }

  const setupBrowserBackHandler = () => {
    if (!shouldShowExitModal.value || popstateHandlerRegistered) return
    const pushFakeEntry = () => {
      window.history.pushState({ exitModal: true }, "", "")
    }
    const handler = () => {
      if (shouldShowExitModal.value) {
        exitModal.value.show = true
      }
    }
    pushFakeEntry()
    window.addEventListener('popstate', handler)
    popstateHandlerRegistered = true
    
    watch(() => exitModal.value.show, (newVal, oldVal) => {
      if (oldVal === true && newVal === false) {
        pushFakeEntry()
      }
    })
    onBeforeUnmount(() => {
      window.removeEventListener('popstate', handler)
      popstateHandlerRegistered = false
    })
  }

  const config: PublicConfig = useRuntimeConfig().public as PublicConfig
  const homepageUrl = config.homepage_url as string || '/'

  return {
    exitModal,
    shouldShowExitModal,
    showExitModal,
    handleLogoClick,
    setupBrowserBackHandler,
    homepageUrl,
  }
}
